import { Reveal, Overline } from "@/components/Reveal";

const IMG = {
  leads: "https://static.prod-images.emergentagent.com/jobs/c7fbc697-e5e1-42c6-9a40-d0f9028d1ed5/images/9b8d6e094d0e550c416b9e8e9001f8061f5430e6a186177c0d012d1e4ab1dd25.png",
  team: "https://static.prod-images.emergentagent.com/jobs/c7fbc697-e5e1-42c6-9a40-d0f9028d1ed5/images/6176c320d91fa717a8420cbaa16db3706cf918375e76d8d55a3d2c1706197445.png",
  campaigns: "https://static.prod-images.emergentagent.com/jobs/c7fbc697-e5e1-42c6-9a40-d0f9028d1ed5/images/1765aaf3f794c533632115633907ad90939cb895e6985bb02c262e6ed2e3cf53.png",
  corporate: "https://static.prod-images.emergentagent.com/jobs/c7fbc697-e5e1-42c6-9a40-d0f9028d1ed5/images/00e22ba06e3b6d7b89058cbaad551b16846e5998e0f51a38ad51e20db5520f12.png",
  autonomy: "https://static.prod-images.emergentagent.com/jobs/c7fbc697-e5e1-42c6-9a40-d0f9028d1ed5/images/59c8d7b25b4b2cf57749640cd8a640099d49514b674d54795f02b38a92a76cae.png",
};

const BULLETS = [
  { img: IMG.leads, title: "Recibe leads calificados de forma continua", desc: "Generados por las campañas centrales de Kairós Learning y por la red de afiliados y agencias autorizadas." },
  { img: IMG.team, title: "Construye y lidera su propio equipo de closers", desc: "Bajo el esquema de compensación que mejor se adapte a su operación: comisión por venta (se recomienda 7%) o un fee mensual fijo." },
  { img: IMG.campaigns, title: "Puede generar campañas propias en su territorio", desc: "Siempre alineadas a los lineamientos de marca de Kairós Learning, para acelerar su crecimiento más allá del flujo central de leads." },
  { img: IMG.corporate, title: "Vende de forma corporativa e institucional", desc: "Instituciones educativas, empresas, gobierno y cámaras de comercio también son mercado: convenios de capacitación, certificación de colaboradores, alianzas empresariales y licitaciones públicas abren un canal con tickets más altos y relaciones de largo plazo." },
  { img: IMG.autonomy, title: "Opera con autonomía real", desc: "El sistema está construido para que el negocio funcione sin depender de la microgestión diaria del franquiciatario, liberándolo para enfocarse en la visión y el liderazgo de su equipo." },
];

export function HowOperator() {
  return (
    <section id="opera" data-testid="opera-section" className="relative py-24 sm:py-32 bg-ivory">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal className="max-w-3xl">
          <Overline>Cómo opera un franquiciatario</Overline>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-midnight mt-6 leading-[1.1]">
            El inversionista lidera. El sistema hace el resto.
          </h2>
          <p className="font-sans text-lg font-light text-midnight/70 mt-6">
            El modelo está diseñado para que el inversionista se enfoque en lo que genera valor: liderar su equipo
            comercial y hacer crecer su territorio. Todo lo demás —demanda, catálogo, marca, respaldo académico— ya está resuelto.
          </p>
        </Reveal>

        <div className="mt-16 space-y-16 lg:space-y-24">
          {BULLETS.map((b, i) => (
            <Reveal key={b.title} delay={0.05}>
              <div className={`grid lg:grid-cols-2 gap-10 lg:gap-16 items-center ${i % 2 ? "lg:[direction:rtl]" : ""}`}>
                <div className="relative lg:[direction:ltr]">
                  <img src={b.img} alt={b.title} className="w-full h-[360px] sm:h-[440px] object-cover" />
                  <div className="absolute inset-0 ring-1 ring-inset ring-midnight/10" />
                  <div className="absolute top-5 left-5 w-12 h-12 bg-crimson flex items-center justify-center">
                    <span className="font-serif text-xl font-black text-ivory tabular-nums">{String(i + 1).padStart(2, "0")}</span>
                  </div>
                </div>
                <div className="lg:[direction:ltr]">
                  <h3 className="font-serif text-2xl sm:text-3xl font-semibold text-midnight leading-tight">{b.title}</h3>
                  <p className="font-sans text-lg font-light text-midnight/70 mt-5 leading-relaxed">{b.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-20 border-t border-midnight/10 pt-10">
            <p className="font-serif text-2xl sm:text-3xl lg:text-4xl font-medium text-midnight leading-snug max-w-4xl">
              100% digital. Sin oficinas. Sin inventario. Sin fronteras físicas para escalar. El momento preciso para
              invertir en el negocio educativo del futuro <span className="text-crimson italic">es ahora</span> — ese es el sentido de nuestro nombre.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
